import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { distinctUntilChanged, filter, map, switchMap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

import { AdminReportsService } from 'rev-portal/admin/reports/AdminReports.Service';
import { AnalyticsService } from 'rev-shared/analytics/Analytics.Service';
import { IVbUiDataGridColDef } from 'rev-shared/ui/dataGrid/columns/IVbUiDataGridColDef';
import { VideoType } from 'rev-shared/media/VideoType';
import { notApplicableValueFormatter } from 'rev-shared/ui/dataGrid/valueFormatters/NotApplicableValueFormatter';
import { PORTAL_VIDEO_PLAYBACK_STATE } from 'rev-shared/bootstrap/AppStateNames';

import styles from 'rev-portal/admin/reports/AdminReports.module.less';
import { ILinkCellRendererParams } from 'rev-shared/ui/dataGrid/cellRenderers/LinkCellRenderer.Component';

@Component({
	selector: 'videos-top-hits-grid',
	templateUrl: './VideosTopHitsGrid.Component.html'
})
export class VideosTopHitsGridComponent implements OnInit {
	@Input() public accountId: string;
	@Input() public header: string;
	@Input() public topHitsCount: number;

	public readonly styles = styles;
	public data$: Observable<any>;

	public readonly notApplicableValueFormatter = params => notApplicableValueFormatter(params, params.data?.VideoType === VideoType.LIVE);
	public readonly titleCellParams: ILinkCellRendererParams<any> = {
		getCellCfg: video => ({
			uiSref: video.canEdit ? PORTAL_VIDEO_PLAYBACK_STATE : undefined,
			uiSrefParams: { videoId: video.Id }
		})
	};
	public columnDefs: IVbUiDataGridColDef[];

	constructor(
		public AnalyticsService: AnalyticsService,
		public ReportsService: AdminReportsService,
		private TranslateService: TranslateService
	){}

	public ngOnInit(): void {
		this.data$ = this.AnalyticsService.dataFetchContext$
			.pipe(
				filter(context => !!context?.startDate),
				distinctUntilChanged(),
				switchMap(context => this.ReportsService.getVideoTopHits(this.accountId, this.topHitsCount, context)),
				map(result => result.videos)
			);
		this.assignColumnDefs();
	}

	private assignColumnDefs(): void {
		this.columnDefs = [
			{
				field: 'Title',
				headerName: this.TranslateService.instant('VideoTitle'),
				sortable: true,
				filter: true,
				cellRenderer: 'link',
				cellRendererParams: this.titleCellParams
			},
			{
				field: 'TotalViews',
				headerName: this.TranslateService.instant('Media_Videos_TotalViews'),
				sortable: true
			},
			{
				field: 'UniqueViews',
				headerName: this.TranslateService.instant('Reports_UniqueViews'),
				sortable: true
			},
			{
				field: 'CompletionRate',
				headerName: this.TranslateService.instant('Reports_CompletionRateInPercentage'),
				sortable: true,
				valueFormatter: this.notApplicableValueFormatter
			}
		];
	}

}
